import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StageComponent, CoreShapeComponent } from 'ng2-konva';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { PageTemplateWindowComponent } from './page-template-window.component';


/**
 * ページパターン設定画面 モジュール設定クラス
 *
 * @export PageTemplateWindowComponent
 * @class PageTemplateWindowComponent
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    StageComponent,
    CoreShapeComponent,
  ],
  declarations: [
    PageTemplateWindowComponent,
  ],
  providers: [
  ],
  exports: [
    PageTemplateWindowComponent,
  ]
})
export class PageTemplateWindowModule {
}
